"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var appnexusUtils_1 = require("../utils/appnexusUtils");
var owa_analytics_1 = require("owa-analytics");
var owa_strings_1 = require("owa-strings");
var owa_mail_ads_shared_1 = require("owa-mail-ads-shared");
var apn;
var marketCountryCode;
var isOneClick;
var loadAppNexusNativeAdsDataPoint;
function fetchAppNexusNativeAds(messageAdType, adMarket, triggerEvent) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var targetDivId, appNexusInvCode;
        return tslib_1.__generator(this, function (_a) {
            loadAppNexusNativeAdsDataPoint = new owa_analytics_1.PerformanceDatapoint('LoadAppNexusNativeAds');
            isOneClick =
                messageAdType == "AppNexusOneClick" /* AppNexusOneClick */ ||
                    messageAdType == "AppNexusOneClickOIO" /* AppNexusOneClickOIO */;
            loadAppNexusNativeAdsDataPoint.addCustomData({
                messageAdType: messageAdType,
                userMarket: adMarket,
                originalMessageAdType: null,
                refreshEvent: triggerEvent,
            });
            marketCountryCode = owa_mail_ads_shared_1.getMarketCountryCode(adMarket);
            targetDivId = 'OwaContainer';
            appNexusInvCode = appnexusUtils_1.contructAppNexusPageGroup(isOneClick);
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var scriptElement = window.document.createElement('script');
                    scriptElement.type = 'text/javascript';
                    scriptElement.src = 'https://acdn.adnxs.com/ast/static/0.10.0/ast.js';
                    scriptElement.onload = function () {
                        apn = window.apntag;
                        apn.anq.push(function () {
                            apn.setPageOpts({
                                member: 280,
                                user: {
                                    dnt: owa_mail_ads_shared_1.getToptOutCookie(),
                                    externalUid: owa_mail_ads_shared_1.getMuidCookie(),
                                },
                            });
                            apn.defineTag({
                                member: 280,
                                invCode: appNexusInvCode,
                                extInvCode: marketCountryCode,
                                sizes: [[1, 1]],
                                targetId: targetDivId,
                                allowedFormats: ['native'],
                                allowSmallerSizes: false,
                                trafficSourceCode: 'pg:' + appNexusInvCode,
                            });
                            apn.onEvent('adLoaded', targetDivId, function (rawAdObject) {
                                var result = [];
                                var appNexusAd = appnexusUtils_1.GenerateAppNexusAd(rawAdObject, messageAdType, adMarket, triggerEvent, isOneClick);
                                if (appNexusAd) {
                                    // Use apn's own fire Impression tracker method to fire the impression tracker required by AppNexus
                                    apn.fireImpressionTrackers(rawAdObject);
                                    result.push(appNexusAd);
                                    loadAppNexusNativeAdsDataPoint.end();
                                    resolve(result);
                                }
                            });
                            apn.onEvent('adRequestFailure', targetDivId, function (rawAdError) {
                                var logClientError = new Error('AppNexusAdRequestFailure: ' +
                                    owa_strings_1.format('AppNexus hits the error. Error code is {0} and Error Message is {1}', rawAdError.code, rawAdError.errMessage));
                                loadAppNexusNativeAdsDataPoint.endWithError(owa_analytics_1.DatapointStatus.ClientError, logClientError);
                                resolve(null);
                            });
                            apn.onEvent('adNoBid', targetDivId, function (rawAdObject) {
                                var logClientError = new Error('AppNexusAdNoBid: ' +
                                    owa_strings_1.format('AppNexus No Bid. Tag id is {0} and auction id is {1}', rawAdObject.tagId, rawAdObject.auctionId));
                                loadAppNexusNativeAdsDataPoint.endWithError(owa_analytics_1.DatapointStatus.ClientError, logClientError);
                                resolve(null);
                            });
                            apn.loadTags();
                            apn.showTag(targetDivId);
                        });
                    };
                    scriptElement.onerror = function () {
                        var logClientError = new Error('AppNexusApnNotLoaded');
                        loadAppNexusNativeAdsDataPoint.endWithError(owa_analytics_1.DatapointStatus.ClientError, logClientError);
                        resolve(null);
                    };
                    window.document.head.appendChild(scriptElement);
                })];
        });
    });
}
exports.default = fetchAppNexusNativeAds;
//# sourceMappingURL=fetchAppNexusNativeAds.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-messagead-orchestration/lib/services/fetchAppNexusNativeAds.js
// module id = 6010
// module chunks = 67